import { useAtomValue } from 'jotai/index';
import React from 'react';
import { BodyMediumRegular, YStack } from 'smoothie';

import { sortBillsAccounts } from '../../../common/utils/billUtils';
import { captureWarning } from '../../../logger/Logger';
import { billsAccountsAtom } from '../../state/BillsAtoms';
import type { BillDetailsEditTypeProps } from '../edit/BillDetailsEditContainer';
import { BillAccountRow, SelectableRow } from './BillRows';

const BillEditAccount = ({ bill, onChange }: BillDetailsEditTypeProps) => {
    const billsAccounts = useAtomValue(billsAccountsAtom);

    if (!billsAccounts.length) {
        captureWarning('No bills-eligible accounts found');
        return (
            <YStack>
                <BodyMediumRegular>No spend accounts found</BodyMediumRegular>
            </YStack>
        );
    }

    const sortedBillAccounts = sortBillsAccounts(billsAccounts);

    return (
        <>
            {sortedBillAccounts?.map((account, i) => {
                return (
                    <SelectableRow
                        key={account.id}
                        isSelected={account.id === bill.accountId}
                        isMultiSelect={false}
                        isFirstRow={i === 0}
                        onSelect={() => {
                            const newBill = { ...bill, accountId: account.id };
                            onChange(newBill);
                        }}
                        rowContentComponent={
                            <BillAccountRow
                                account={account}
                                viewType="account_selection"
                            />
                        }
                    />
                );
            })}
        </>
    );
};

export default BillEditAccount;
